import { call, all } from "redux-saga/effects";

import { watchAuthActions } from "./authSaga";
import { watchProjectActions } from "./projectsSaga";
import { watchFileActions } from "./filesSaga";
import { watchDatasetActions } from "./datasetSaga";
import { watchProjectPagesSaga } from "./pagesSaga";
import { watchWidgetsSaga } from "./widgetsSaga";
import { watchCommentActions } from "./commentsSaga";
import { watchProfileActions } from "./profilesSaga";
import { watchTeamsSaga } from "./teamsSaga";
import { watchUsersSaga } from "./usersSaga";

export function* rootSaga() {
  yield all([
    call(watchAuthActions),
    call(watchProjectActions),
    call(watchFileActions),
    call(watchDatasetActions),
    call(watchProjectPagesSaga),
    call(watchWidgetsSaga),
    call(watchCommentActions),
    call(watchProfileActions),
    call(watchTeamsSaga),
    call(watchUsersSaga),
  ]);
}
